module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-114x114-82236dd5c6ba4c6be7d837a1a4fc48ca.png";